<template>
    <div id="choose-your-vision">
        <div class="row justify-content-center">
            <div class="col-lg col-12 pr-lg-0 pl-lg-0 margin-top-130-px">
                <div class="container pr-lg-0 pl-lg-0">
                    <div class="row">
                        <div class="col-lg-2 col-12 order-lg-last pr-lg-0 pl-lg-0">
                            <h1 class="w-100 home-title text-lg-center text-md-center go-over-right">02</h1>
                        </div>
                        <div class="col-lg col-12 pr-lg-0 pl-lg-0pt-3">
                            <h5 class="noto-sans-kr text-lg-right text-center">Browse Jeweler Profiles</h5>
                            <p class="noto-sans-font-title text-lg-right text-center steps-p mw-280-px float-lg-right float-none">
                                Review detailed profiles with jeweler contact info, areas of expertise, inventory, and customer feedback.
                            </p>
                        </div>
                    </div>
                    <div class="w-100"></div>
                    <div class="col-lg col-6 right-border float-left"></div>
                </div>
            </div>
            <div data-aos="fade-up" data-aos-duration="1200" class="col-lg col-12 order-lg-last pr-lg-0 pl-lg-0">
                <img-webp classs="zxc mx-auto img-fluid steps-img-md" alt="Diamond ring design by jeweler" src="/images/home/choose-your-vision.png"></img-webp>
                <span class="img-floating-text">Discover Local Experts</span>
            </div>
        </div>
    </div>
</template>

<script>
import ImgWebp from "../../../../components/ImgWebp";

export default {
    name: "choose-your-vision",
    components: {
        "img-webp": ImgWebp,
    },
};
</script>

<style lang="scss" scoped>
#choose-your-vision {
    .right-border {
        border-right: 1px solid #000000;
        height: 46px;
    }
    a {
        text-decoration: underline !important;
    }
    .go-over-right {
        right: calc(15px - 50%);
        position: absolute;
    }
    .steps-p {
        padding-bottom: 0;
        min-height: 84px;
    }
    @media (max-width: 991px) {
        .left-border,
        .right-border {
            border-width: 2px;
            height: 76px;
            margin-left: 0;
            margin-right: 0;
            margin-bottom: 60px;
        }
        .go-over-right,
        .go-over-left {
            margin-right: 0 !important;
            margin-left: 0 !important;
            left: 0;
            right: 0;
            position: relative;
        }
    }
    .img-floating-text {
        text-shadow: 0 0 14px rgba(0, 0, 0, 0.5);
        font-family: "Satisfy", cursive;
        font-size: 30px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 45%;
        margin: auto;
        z-index: 1;
    }
}
</style>
